import http from '@/utils/services/http'

const verificaFiltroPatio = patio => patio !== null && typeof patio !== 'undefined' ? `&patio=${patio}` : ''

export function gerarRelatorioEstoque (data1, data2, tipoProcesso = 0, patio) {
  return http.get(`/api/relatorios-gerenciais/estoque?data1=${data1}&data2=${data2}&tipoProcesso=${tipoProcesso}&patio=${patio}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioEntradas (data1, data2, tipoProcesso = 0, patio = null) {
  return http.get(`/api/relatorios-gerenciais/entradas?data1=${data1}&data2=${data2}&tipoProcesso=${tipoProcesso}${verificaFiltroPatio(patio)}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioSaidas (data1, data2, tipoProcesso = 0, patio = null) {
  return http.get(`/api/relatorios-gerenciais/saidas?data1=${data1}&data2=${data2}&tipoProcesso=${tipoProcesso}${verificaFiltroPatio(patio)}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioBloqueadosLeilao (data1, data2, tipoProcesso = 0, patio) {
  return http.get(`/api/relatorios-gerenciais/bloqueados-leilao?data1=${data1}&data2=${data2}&tipoProcesso=${tipoProcesso}&patio=${patio}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioTransferidosPatioCentral (data1, data2) {
  return http.get(`/api/relatorios-gerenciais/trasnf-patio-central?data1=${data1}&data2=${data2}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioRelacionados (leilao) {
  return http.get(`/api/relatorios-gerenciais/relacionados-leilao?leilao=${leilao}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioVendasPorArrematantes (leilao) {
  return http.get(`/api/relatorios-gerenciais/vendas-por-arrematante?leilao=${leilao}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioFinanceiro (data1, data2, patio, tipoProcesso = 0) {
  return http.get(`/api/relatorios-gerenciais/financeiro?data1=${data1}&data2=${data2}&patio=${patio}&tipoProcesso=${tipoProcesso}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioPrestacaoDeContasEntradas (tipoProcesso = 0) {
  return http.get(`/api/relatorios-gerenciais/prestacao-contas-entradas?&tipoProcesso=${tipoProcesso}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioPrestacaoDeContasPatio (tipoProcesso = 0) {
  return http.get(`/api/relatorios-gerenciais/prestacao-contas-patio?&tipoProcesso=${tipoProcesso}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioInventario () {
  return http.get(`/api/relatorios-gerenciais/inventario`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioLeiloeiro (leilao) {
  return http.get(`/api/relatorios-gerenciais/relatorio-leiloeiro?leilao=${leilao}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarRelatorioPrestacaoDeContas (leilao) {
  return http.get(`/api/relatorios-gerenciais/relatorio-prestacao-de-contas?leilao=${leilao}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function getBasicData () {
  return http.get(`/api/relatorios-gerenciais/basic-data`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./src/domain/relatorios/services/relatorios-gerenciais.js